export default __webpack_public_path__ + "static/media/wayfarer.68ea861c.png";